(ns ui.view.card.associated-entities.event
  (:require [re-frame.core :as rf]
            [frontend.controller.websocket.event :as ws]
            [ui.view.card.associated-entities.model :as model]
            [ui.view.card.event :as common-event]
            [ui.view.card.model :as common-model]

              ;; TODO: delete
            [frontend.view.modals.association.view :as association-modal]
            [frontend.view.modals.textarea.view :as textarea-modal]
            [frontend.view.modals.events :as modals]
            [clojure.string :as string]
            [common.localization :as loc]
            [common.util :as cu]
            [ui.cofx.response :as response-cofx]))

(rf/reg-event-db
 ::toggle-table-group-by-association-type
 [rf/trim-v]
 (fn [db [{:keys [card card-state-path] :as _ctx} table-index]]
   (let [table-config (-> card
                          :card/config
                          :tables
                          (nth table-index))
         default-value (:group-by-association-type? table-config)
         path (model/table-group-by-association-type-full-path card-state-path table-index)
         user-set-value (get-in db path)
         current-value (if (boolean? user-set-value)
                         user-set-value
                         default-value)]
     (assoc-in db path (not current-value)))))

(rf/reg-event-db
 ::set-table-expanded
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx} {:keys [table-index expanded?] :as _args}]]
   (-> db
       (assoc-in (model/table-expanded-full-path card-state-path table-index) expanded?))))

(rf/reg-event-db
 ::set-table-row-group-expanded
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx} {:keys [table-index group-key expanded?]}]]
   (let [path (model/table-row-group-expanded-full-path card-state-path table-index group-key)]
     (assoc-in db path expanded?))))

(rf/reg-event-db
 ::set-table-sort-model
 [rf/trim-v]
 (fn [db [{:keys [card-state-path] :as _ctx} {:keys [table-index sort-model]}]]
   (assoc-in db (model/table-sort-model-full-path card-state-path table-index) sort-model)))

;; TODO: this will cause circular dependency likely in the future,
;; since we're requiring other card specific data fetching logic in 
; common card event. Think how the events should be structured and located in code
(rf/reg-event-fx
 ::refetch-card-data
 [rf/trim-v]
 (fn [_cofx [ctx]]
   (let [event (common-event/create-fetch-card-data-event ctx)]
     {:fx [[:dispatch event]]})))

  ;; TODO: move this to some generic location
(rf/reg-fx
 ::open-modal
 (fn [{:keys [modal-key args]}]
   (modals/open-modal! modal-key args)))

(rf/reg-event-fx
 ::open-add-association-modal
 [rf/trim-v]
 (fn [_cofx [{:keys [card entity-id] :as ctx} target-entity-type]]
   (let [card-entity-type (:card/entity-type card)]
     {::open-modal {:modal-key association-modal/modal-key
                    :args   {:entity-id      entity-id
                             :entity-type    card-entity-type
                             :target-type    target-entity-type
                             :create-on-fly? (not= target-entity-type :entity.type/oppo)
                             :success-callback-event [::refetch-card-data ctx]}}})))

(rf/reg-event-fx
 ::remove-association-success
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [{:keys [db stale-response?]}
      [{:keys [card-state-path] :as _ctx}
       {:keys [association-id associated-entity-id] :as _args}
       _resp]]
   (when-not stale-response?
     (let [card-entities-by-id (get-in db (common-model/entities-full-path card-state-path))
           remaining-associations-where-party
           (->> card-entities-by-id
                (filterv (fn [[eid entity]]
                           (let [source (:entity-association/source-entity entity)
                                 target (:entity-association/target-entity entity)]
                             (and (not= eid association-id)
                                  (or (= source associated-entity-id)
                                      (= target associated-entity-id)))))))
           entity-ids-to-remove (concat [association-id]
                                        (when (empty? remaining-associations-where-party)
                                          [associated-entity-id]))
           new-db (common-model/remove-entities db
                                                card-state-path
                                                entity-ids-to-remove)]
       {:db new-db}))))

(rf/reg-event-fx
 ::remove-association-error
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [_cofx [resp]]
     ;; TODO
   (js/console.log "remove association error " resp)))

(rf/reg-event-fx
 ::remove-association
 [rf/trim-v]
 (fn [_cofx [ctx {:keys [association-id associated-entity-id] :as args}]]
   {::ws/send {:id :entity/remove-association
               :body {:entity-id      associated-entity-id
                      :association-id association-id}
               :on-success [::remove-association-success ctx args]
               :on-error   [::remove-association-error ctx]}}))

(rf/reg-event-fx
 ::update-comment-error
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [_cofx [_ctx _args resp]]
     ;; TODO
   (js/console.log "update comment error" resp)))

(rf/reg-event-fx
 ::update-comment
 [rf/trim-v]
 (fn [_cofx [ctx {:keys [new-comment comment-attribute association-id] :as _args}]]
   {::ws/send {:id (if (cu/blank-value? new-comment)
                     :entity/remove-attribute
                     :entity/update-attribute)
               :body {:db/id     association-id
                      :attribute comment-attribute
                      :value     new-comment}
               :on-success [::refetch-card-data ctx]
               :on-error [::update-comment-error ctx]}}))

(rf/reg-event-fx
 ::open-edit-comment-modal
 [rf/trim-v]
 (fn [_ [ctx {:keys [comment] :as args}]]
   {::open-modal {:modal-key textarea-modal/modal-key
                  :args   {:title-text  (loc/tr :edit)
                           :button-text (loc/tr :ok)
                           :value       comment
                           :on-submit!  (fn [new-comment]
                                          (rf/dispatch [::update-comment ctx (assoc args :new-comment new-comment)]))}}}))
